import { TextInput } from 'flowbite-react';
import React, { ChangeEvent, KeyboardEvent, MutableRefObject } from 'react';
import { useThemeContext } from 'src/context/ThemeProvider';

interface Props {
	isMobileScreen: boolean;
	handlePaste: (event: React.ClipboardEvent<HTMLInputElement>) => void;
	handleKeyDown: (index: number, event: React.KeyboardEvent<HTMLInputElement>) => void;
	handleChange: (index: number, event: React.ChangeEvent<HTMLInputElement>) => void;
	otp: string[];
	inputRefs: MutableRefObject<(HTMLInputElement | null)[]>;
}

const OtpInput = ({ isMobileScreen, handlePaste, otp, handleChange, handleKeyDown, inputRefs }: Props) => {
	const { themeMode } = useThemeContext();
	return (
		<div className="flex">
			<div className="flex flex-wrap gap-2">
				{otp.map((digit, index) => (
					<TextInput
						sizing="lg"
						autoFocus={index === 0}
						style={{
							color: themeMode === 'dark' ? 'white' : 'black',
							backgroundColor: themeMode === 'dark' ? '#374151' : 'white',
							border: themeMode === 'dark' ? '1px solid #6B7280' : '1px solid #D1D5DB',
							width: '48px',
							height: '48px',
							textAlign: 'center',
							fontSize: '24px',
						}}
						key={index}
						type={isMobileScreen ? 'tel' : 'text'}
						maxLength={1}
						value={digit}
						onChange={(event: ChangeEvent<HTMLInputElement>) => handleChange(index, event)}
						onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => handleKeyDown(index, event)}
						onPaste={handlePaste}
						ref={ref => (inputRefs.current[index] = ref)}
					/>
				))}
			</div>
		</div>
	);
};

export default OtpInput;
